export enum ResourceType {
  Job = "Job",
  OrderItem = "OrderItem",
  WorkflowInstance = "WorkflowInstance",
}
